import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
// import FormAction from 'app/modules/Accounting/reports/TaxExport/TaxExportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class SalesPrintConfigActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/PrintConfiguration/PrintConfiguration")
	}

	render() {
		return (
			<Activity 
				name="PrintConfig"
				RenderedComponent={this.RenderedComponent}
				context="PrintConfig"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SalesPrintConfigActivity)
